import axios from "axios";

export const API_URL = "https://apiclimas.abdielaldana.com";

export const api = axios.create({
    baseURL: API_URL,
});